/**
 * 系统级筛选缓存数据：
 * 规范参数, XXX 自定义数据名称, target 后端接口给出的原接口映射名称, params 原接口传的参数
 * XXX: {
    target: 'new_filter_list_region_country',
    params: {
      type: [
        {
          tabName: 'mobile',
        },
      ],
      item: [
        {
          tabName: '',
        },
      ],
      filter_type: 'metric_table',
    },
  },
 */
const commonParams = {
  datasource: {
    adjust_metric: true
  },
  game_detail_overlap_region: {},
  overview_truedata_metric_mobile: {},
  overview_truedata_metric_pc_console: {},
  platform: {},
  steam_news_types: {},
  mobileRegionCountry: {
    target: 'new_filter_list_region_country',
    params: {
      type: [
        {
          tabName: 'mobile',
        },
      ],
      item: [
        {
          tabName: '',
        },
      ],
      filter_type: 'common',
    },
  },
  metricTableRegionCountry: {
    target: 'new_filter_list_region_country',
    params: {
      type: [
        {
          tabName: 'mobile',
        },
      ],
      item: [
        {
          tabName: '',
        },
      ],
      filter_type: 'metric_table',
    },
  },
  filterTags: {
    target: 'filter_tags',
  },
  gameEngineMobile: {
    target: 'filter_game_engine',
    params: {
      entity_type: 'mobile',
    },
  },
  gameEngineCombine: {
    target: 'filter_game_engine',
    params: {
      entity_type: 'combine',
    },
  },
  publisherClassCombine: {
    target: 'filter_publisher_class',
    params: null,
  },
  gsdDeviceSegment: {
    target: 'get_gsd_device_segment_filter',
    params: {},
  },
  countryMap: {
    target: 'region_list',
  },
  genreMap: {
    target: 'filter_genre',
    params: {
      entity_type: ['mobile'],
      need_filter: true,
    },
  },
  gamesCompareShortcut: {
    target: 'game_config',
    params: {
      key: 'compare_shortcut*',
    },
  },
  // 全量品类
  // fullGenre: {
  //   target: 'filter_genre',
  //   params: {
  //     entity_type: ['mobile'],
  //     need_filter: false,
  //   },
  // },
  lowCodeTemplate: {
    target: 'game_config',
    params: {
      key: 'lowcode_template_*',
    },
  },
  // 查询 数据隐私（弹窗内容的配置）
  intelligenceDataPrivacy: {
    target: 'game_config',
    params: {
      key: 'intelligence_data_privacy_content_*',
    },
  },
};

export const condParams = {
  ...commonParams,
};
